/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { BackendTypesEnum } from './BackendTypesEnum';
import {
    BackendTypesEnumFromJSON,
    BackendTypesEnumFromJSONTyped,
    BackendTypesEnumToJSON,
} from './BackendTypesEnum';
import type { ClusterAccountSchema } from './ClusterAccountSchema';
import {
    ClusterAccountSchemaFromJSON,
    ClusterAccountSchemaFromJSONTyped,
    ClusterAccountSchemaToJSON,
} from './ClusterAccountSchema';
import type { ClusterInfrastructureLite } from './ClusterInfrastructureLite';
import {
    ClusterInfrastructureLiteFromJSON,
    ClusterInfrastructureLiteFromJSONTyped,
    ClusterInfrastructureLiteToJSON,
} from './ClusterInfrastructureLite';
import type { ClusterMetricsId } from './ClusterMetricsId';
import {
    ClusterMetricsIdFromJSON,
    ClusterMetricsIdFromJSONTyped,
    ClusterMetricsIdToJSON,
} from './ClusterMetricsId';
import type { ClusterOptionsFrontendSchema } from './ClusterOptionsFrontendSchema';
import {
    ClusterOptionsFrontendSchemaFromJSON,
    ClusterOptionsFrontendSchemaFromJSONTyped,
    ClusterOptionsFrontendSchemaToJSON,
} from './ClusterOptionsFrontendSchema';
import type { ClusterStateSchema } from './ClusterStateSchema';
import {
    ClusterStateSchemaFromJSON,
    ClusterStateSchemaFromJSONTyped,
    ClusterStateSchemaToJSON,
} from './ClusterStateSchema';
import type { ClusterTag } from './ClusterTag';
import {
    ClusterTagFromJSON,
    ClusterTagFromJSONTyped,
    ClusterTagToJSON,
} from './ClusterTag';
import type { ClusterTypeEnum } from './ClusterTypeEnum';
import {
    ClusterTypeEnumFromJSON,
    ClusterTypeEnumFromJSONTyped,
    ClusterTypeEnumToJSON,
} from './ClusterTypeEnum';
import type { ClusterUserSchema } from './ClusterUserSchema';
import {
    ClusterUserSchemaFromJSON,
    ClusterUserSchemaFromJSONTyped,
    ClusterUserSchemaToJSON,
} from './ClusterUserSchema';
import type { MetricFlag } from './MetricFlag';
import {
    MetricFlagFromJSON,
    MetricFlagFromJSONTyped,
    MetricFlagToJSON,
} from './MetricFlag';
import type { SchedulerSchema } from './SchedulerSchema';
import {
    SchedulerSchemaFromJSON,
    SchedulerSchemaFromJSONTyped,
    SchedulerSchemaToJSON,
} from './SchedulerSchema';
import type { SoftwareEnvironmentAliasSchema } from './SoftwareEnvironmentAliasSchema';
import {
    SoftwareEnvironmentAliasSchemaFromJSON,
    SoftwareEnvironmentAliasSchemaFromJSONTyped,
    SoftwareEnvironmentAliasSchemaToJSON,
} from './SoftwareEnvironmentAliasSchema';
import type { TagAlertHitWithMessageSchema } from './TagAlertHitWithMessageSchema';
import {
    TagAlertHitWithMessageSchemaFromJSON,
    TagAlertHitWithMessageSchemaFromJSONTyped,
    TagAlertHitWithMessageSchemaToJSON,
} from './TagAlertHitWithMessageSchema';
import type { WorkerFrontendSchema } from './WorkerFrontendSchema';
import {
    WorkerFrontendSchemaFromJSON,
    WorkerFrontendSchemaFromJSONTyped,
    WorkerFrontendSchemaToJSON,
} from './WorkerFrontendSchema';

/**
 * 
 * @export
 * @interface ClusterFrontendSchema
 */
export interface ClusterFrontendSchema {
    /**
     * 
     * @type {number}
     * @memberof ClusterFrontendSchema
     */
    id: number;
    /**
     * 
     * @type {Date}
     * @memberof ClusterFrontendSchema
     */
    created: Date;
    /**
     * 
     * @type {Date}
     * @memberof ClusterFrontendSchema
     */
    updated: Date;
    /**
     * 
     * @type {string}
     * @memberof ClusterFrontendSchema
     */
    name: string;
    /**
     * 
     * @type {ClusterAccountSchema}
     * @memberof ClusterFrontendSchema
     */
    account: ClusterAccountSchema;
    /**
     * 
     * @type {ClusterUserSchema}
     * @memberof ClusterFrontendSchema
     */
    creator: ClusterUserSchema;
    /**
     * 
     * @type {number}
     * @memberof ClusterFrontendSchema
     */
    accountId: number;
    /**
     * 
     * @type {BackendTypesEnum}
     * @memberof ClusterFrontendSchema
     */
    backendType: BackendTypesEnum;
    /**
     * 
     * @type {boolean}
     * @memberof ClusterFrontendSchema
     */
    coiledHosted: boolean;
    /**
     * 
     * @type {Date}
     * @memberof ClusterFrontendSchema
     */
    schedulerReadyAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ClusterFrontendSchema
     */
    terminatingAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ClusterFrontendSchema
     */
    finishedAt?: Date;
    /**
     * 
     * @type {number}
     * @memberof ClusterFrontendSchema
     */
    billableTime?: number;
    /**
     * 
     * @type {number}
     * @memberof ClusterFrontendSchema
     */
    costPerHour?: number;
    /**
     * 
     * @type {number}
     * @memberof ClusterFrontendSchema
     */
    totalCost?: number;
    /**
     * 
     * @type {number}
     * @memberof ClusterFrontendSchema
     */
    desiredWorkers: number;
    /**
     * 
     * @type {string}
     * @memberof ClusterFrontendSchema
     */
    schedulerDashboardHostname?: string;
    /**
     * 
     * @type {ClusterStateSchema}
     * @memberof ClusterFrontendSchema
     */
    currentState: ClusterStateSchema;
    /**
     * 
     * @type {SchedulerSchema}
     * @memberof ClusterFrontendSchema
     */
    scheduler: SchedulerSchema;
    /**
     * 
     * @type {Array<WorkerFrontendSchema>}
     * @memberof ClusterFrontendSchema
     */
    workersExceptUnprovisionable: Array<WorkerFrontendSchema>;
    /**
     * 
     * @type {boolean}
     * @memberof ClusterFrontendSchema
     */
    stopDesired: boolean;
    /**
     * 
     * @type {string}
     * @memberof ClusterFrontendSchema
     */
    stopReason?: string;
    /**
     * 
     * @type {Date}
     * @memberof ClusterFrontendSchema
     */
    stopRequestedDt?: Date;
    /**
     * 
     * @type {ClusterOptionsFrontendSchema}
     * @memberof ClusterFrontendSchema
     */
    clusterOptions: ClusterOptionsFrontendSchema;
    /**
     * 
     * @type {number}
     * @memberof ClusterFrontendSchema
     */
    schedulerPort: number;
    /**
     * 
     * @type {ClusterInfrastructureLite}
     * @memberof ClusterFrontendSchema
     */
    clusterInfra?: ClusterInfrastructureLite;
    /**
     * 
     * @type {ClusterMetricsId}
     * @memberof ClusterFrontendSchema
     */
    clusterMetrics?: ClusterMetricsId;
    /**
     * 
     * @type {string}
     * @memberof ClusterFrontendSchema
     */
    internalGrafanaLink?: string;
    /**
     * 
     * @type {string}
     * @memberof ClusterFrontendSchema
     */
    externalGrafanaLink?: string;
    /**
     * 
     * @type {Array<MetricFlag>}
     * @memberof ClusterFrontendSchema
     */
    metricFlags: Array<MetricFlag>;
    /**
     * 
     * @type {string}
     * @memberof ClusterFrontendSchema
     */
    daskConfigYaml?: string;
    /**
     * 
     * @type {Array<ClusterTag>}
     * @memberof ClusterFrontendSchema
     */
    tagList: Array<ClusterTag>;
    /**
     * 
     * @type {Array<TagAlertHitWithMessageSchema>}
     * @memberof ClusterFrontendSchema
     */
    alertList: Array<TagAlertHitWithMessageSchema>;
    /**
     * 
     * @type {number}
     * @memberof ClusterFrontendSchema
     */
    senvBuildId?: number;
    /**
     * 
     * @type {SoftwareEnvironmentAliasSchema}
     * @memberof ClusterFrontendSchema
     */
    senvAlias?: SoftwareEnvironmentAliasSchema;
    /**
     * 
     * @type {number}
     * @memberof ClusterFrontendSchema
     */
    cloudCostPerHour?: number;
    /**
     * 
     * @type {number}
     * @memberof ClusterFrontendSchema
     */
    cloudTotalCost?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ClusterFrontendSchema
     */
    pauseOnExit?: boolean;
    /**
     * 
     * @type {ClusterTypeEnum}
     * @memberof ClusterFrontendSchema
     */
    clusterType?: ClusterTypeEnum;
}

/**
 * Check if a given object implements the ClusterFrontendSchema interface.
 */
export function instanceOfClusterFrontendSchema(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "created" in value;
    isInstance = isInstance && "updated" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "account" in value;
    isInstance = isInstance && "creator" in value;
    isInstance = isInstance && "accountId" in value;
    isInstance = isInstance && "backendType" in value;
    isInstance = isInstance && "coiledHosted" in value;
    isInstance = isInstance && "desiredWorkers" in value;
    isInstance = isInstance && "currentState" in value;
    isInstance = isInstance && "scheduler" in value;
    isInstance = isInstance && "workersExceptUnprovisionable" in value;
    isInstance = isInstance && "stopDesired" in value;
    isInstance = isInstance && "clusterOptions" in value;
    isInstance = isInstance && "schedulerPort" in value;
    isInstance = isInstance && "metricFlags" in value;
    isInstance = isInstance && "tagList" in value;
    isInstance = isInstance && "alertList" in value;

    return isInstance;
}

export function ClusterFrontendSchemaFromJSON(json: any): ClusterFrontendSchema {
    return ClusterFrontendSchemaFromJSONTyped(json, false);
}

export function ClusterFrontendSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClusterFrontendSchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'created': (new Date(json['created'])),
        'updated': (new Date(json['updated'])),
        'name': json['name'],
        'account': ClusterAccountSchemaFromJSON(json['account']),
        'creator': ClusterUserSchemaFromJSON(json['creator']),
        'accountId': json['account_id'],
        'backendType': BackendTypesEnumFromJSON(json['backend_type']),
        'coiledHosted': json['coiled_hosted'],
        'schedulerReadyAt': !exists(json, 'scheduler_ready_at') ? undefined : (new Date(json['scheduler_ready_at'])),
        'terminatingAt': !exists(json, 'terminating_at') ? undefined : (new Date(json['terminating_at'])),
        'finishedAt': !exists(json, 'finished_at') ? undefined : (new Date(json['finished_at'])),
        'billableTime': !exists(json, 'billable_time') ? undefined : json['billable_time'],
        'costPerHour': !exists(json, 'cost_per_hour') ? undefined : json['cost_per_hour'],
        'totalCost': !exists(json, 'total_cost') ? undefined : json['total_cost'],
        'desiredWorkers': json['desired_workers'],
        'schedulerDashboardHostname': !exists(json, 'scheduler_dashboard_hostname') ? undefined : json['scheduler_dashboard_hostname'],
        'currentState': ClusterStateSchemaFromJSON(json['current_state']),
        'scheduler': SchedulerSchemaFromJSON(json['scheduler']),
        'workersExceptUnprovisionable': ((json['workers_except_unprovisionable'] as Array<any>).map(WorkerFrontendSchemaFromJSON)),
        'stopDesired': json['stop_desired'],
        'stopReason': !exists(json, 'stop_reason') ? undefined : json['stop_reason'],
        'stopRequestedDt': !exists(json, 'stop_requested_dt') ? undefined : (new Date(json['stop_requested_dt'])),
        'clusterOptions': ClusterOptionsFrontendSchemaFromJSON(json['cluster_options']),
        'schedulerPort': json['scheduler_port'],
        'clusterInfra': !exists(json, 'cluster_infra') ? undefined : ClusterInfrastructureLiteFromJSON(json['cluster_infra']),
        'clusterMetrics': !exists(json, 'cluster_metrics') ? undefined : ClusterMetricsIdFromJSON(json['cluster_metrics']),
        'internalGrafanaLink': !exists(json, 'internal_grafana_link') ? undefined : json['internal_grafana_link'],
        'externalGrafanaLink': !exists(json, 'external_grafana_link') ? undefined : json['external_grafana_link'],
        'metricFlags': ((json['metric_flags'] as Array<any>).map(MetricFlagFromJSON)),
        'daskConfigYaml': !exists(json, 'dask_config_yaml') ? undefined : json['dask_config_yaml'],
        'tagList': ((json['tag_list'] as Array<any>).map(ClusterTagFromJSON)),
        'alertList': ((json['alert_list'] as Array<any>).map(TagAlertHitWithMessageSchemaFromJSON)),
        'senvBuildId': !exists(json, 'senv_build_id') ? undefined : json['senv_build_id'],
        'senvAlias': !exists(json, 'senv_alias') ? undefined : SoftwareEnvironmentAliasSchemaFromJSON(json['senv_alias']),
        'cloudCostPerHour': !exists(json, 'cloud_cost_per_hour') ? undefined : json['cloud_cost_per_hour'],
        'cloudTotalCost': !exists(json, 'cloud_total_cost') ? undefined : json['cloud_total_cost'],
        'pauseOnExit': !exists(json, 'pause_on_exit') ? undefined : json['pause_on_exit'],
        'clusterType': !exists(json, 'cluster_type') ? undefined : ClusterTypeEnumFromJSON(json['cluster_type']),
    };
}

export function ClusterFrontendSchemaToJSON(value?: ClusterFrontendSchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'created': (value.created.toISOString()),
        'updated': (value.updated.toISOString()),
        'name': value.name,
        'account': ClusterAccountSchemaToJSON(value.account),
        'creator': ClusterUserSchemaToJSON(value.creator),
        'account_id': value.accountId,
        'backend_type': BackendTypesEnumToJSON(value.backendType),
        'coiled_hosted': value.coiledHosted,
        'scheduler_ready_at': value.schedulerReadyAt === undefined ? undefined : (value.schedulerReadyAt.toISOString()),
        'terminating_at': value.terminatingAt === undefined ? undefined : (value.terminatingAt.toISOString()),
        'finished_at': value.finishedAt === undefined ? undefined : (value.finishedAt.toISOString()),
        'billable_time': value.billableTime,
        'cost_per_hour': value.costPerHour,
        'total_cost': value.totalCost,
        'desired_workers': value.desiredWorkers,
        'scheduler_dashboard_hostname': value.schedulerDashboardHostname,
        'current_state': ClusterStateSchemaToJSON(value.currentState),
        'scheduler': SchedulerSchemaToJSON(value.scheduler),
        'workers_except_unprovisionable': ((value.workersExceptUnprovisionable as Array<any>).map(WorkerFrontendSchemaToJSON)),
        'stop_desired': value.stopDesired,
        'stop_reason': value.stopReason,
        'stop_requested_dt': value.stopRequestedDt === undefined ? undefined : (value.stopRequestedDt.toISOString()),
        'cluster_options': ClusterOptionsFrontendSchemaToJSON(value.clusterOptions),
        'scheduler_port': value.schedulerPort,
        'cluster_infra': ClusterInfrastructureLiteToJSON(value.clusterInfra),
        'cluster_metrics': ClusterMetricsIdToJSON(value.clusterMetrics),
        'internal_grafana_link': value.internalGrafanaLink,
        'external_grafana_link': value.externalGrafanaLink,
        'metric_flags': ((value.metricFlags as Array<any>).map(MetricFlagToJSON)),
        'dask_config_yaml': value.daskConfigYaml,
        'tag_list': ((value.tagList as Array<any>).map(ClusterTagToJSON)),
        'alert_list': ((value.alertList as Array<any>).map(TagAlertHitWithMessageSchemaToJSON)),
        'senv_build_id': value.senvBuildId,
        'senv_alias': SoftwareEnvironmentAliasSchemaToJSON(value.senvAlias),
        'cloud_cost_per_hour': value.cloudCostPerHour,
        'cloud_total_cost': value.cloudTotalCost,
        'pause_on_exit': value.pauseOnExit,
        'cluster_type': ClusterTypeEnumToJSON(value.clusterType),
    };
}

